"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className, clickable) {
    return {
        root: styling_1.mergeStyles("listing-store-front-tile", className, styles.root, clickable && styles.clickableRoot),
        top: styling_1.mergeStyles("listing-store-front-tile-top", styles.top),
        banner: styling_1.mergeStyles("listing-store-front-tile-banner", styles.banner),
        content: styling_1.mergeStyles("listing-store-front-tile-content", styles.content),
        title: styling_1.mergeStyles("listing-store-front-tile-title", styles.title),
        shortDescription: styling_1.mergeStyles("listing-store-front-tile-short-description", styles.shortDescription),
        footer: styling_1.mergeStyles("listing-store-front-tile-footer", styles.footer)
    };
});
exports.getClassNames = getClassNames;
